import { SpreadsheetGrid } from "@components/spreadsheet/SpreadsheetGrid";
import { CellType } from "@components/spreadsheet/cells";
import type { ColumnDef, SpreadsheetData } from "@components/spreadsheet/types";
import styles from "../SpreadsheetPlayground.module.scss";
import { formatSumAmount } from "./spreadsheetPlaygroundShared";

export const TOTALS_HINT =
    "Edit amounts. The totals row at the bottom is driven by the Amount column aggregation.";

const COLUMNS: ColumnDef[] = [
    {
        field: "name",
        label: "Name",
        cellType: CellType.STRING,
    },
    {
        field: "category",
        label: "Category",
        cellType: CellType.STRING,
    },
    {
        field: "amount",
        label: "Amount",
        cellType: CellType.NUMBER,
        isMonetary: true,
        aggregation: formatSumAmount,
    },
];

export interface TotalsScenarioProps {
    data: SpreadsheetData;
    onChange: (data: SpreadsheetData) => void;
}

export const TotalsScenario = ({ data, onChange }: TotalsScenarioProps) => (
    <>
        <span>{TOTALS_HINT}</span>
        <div className={styles.gridFrame}>
            <SpreadsheetGrid
                className={styles.grid}
                data={data}
                columns={COLUMNS}
                onChange={onChange}
                showTotalsRow
                overflow="auto"
                gridTemplateColumns="minmax(240px, 1fr) minmax(160px, 1fr) 160px"
            />
        </div>
        <div className={styles.output}>
            <span>State</span>
            <pre role="status" aria-live="polite">
                {`Total: ${formatSumAmount(data)}`}
            </pre>
        </div>
    </>
);
